/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import PropTypes from 'prop-types';
import FormFields from "./formField";
import { getValidationRules } from "../../utils/Validation/GetValidationRule";
import { ValidateAll, Validate } from "../../utils/Validation/Validation";

const FormCreator = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(props.initialState);
  const [validState, setValidState] = useState({
    isValid: true,
    error: {},
  });
  const [validationRules, setValidationRules] = useState({});

  useEffect(() => {
    if (props.formSetting && props.formSetting.isViewOnly) {
      const valRule = getValidationRules(props.formFields);
      setValidationRules(valRule);
      return;
    }
    const valRule = getValidationRules(props.formFields);
    setValidationRules(valRule);
  }, [props.formFields, props.onFormDataChange, props.onActionChange]);

  // reset the initial state 
  useEffect(() => {
    setFormData(props.initialState);
    setValidState({
      isValid: true,
      error: {},
    });

    return () => {

    }
  }, [props.initialState]);

  useImperativeHandle(
    ref,
    () => {
      return {
        getFormData: () => {
          if (isValidForm())
            return formData;
        },
        getFieldValue: (fieldName) => formData[fieldName],
      };
    },
    [formData, validState, validationRules],
  );

  const isValidForm = () => {
    const validation = ValidateAll(formData, validationRules);
    if (!validation.isValid) {
      setValidState(validation);

    }
    return validation.isValid;
  };

  const handleStateChange = (updatedData, e) => {
    setFormData(updatedData);
    if (props.onFormDataChange) {
      props.onFormDataChange(updatedData, e)
    }
  };

  const handleFormFieldChange = (dataField, value, updatedData, e) => {
    if (props.onFormFieldValueChange) {
      props.onFormFieldValueChange(dataField, value, updatedData, e)
    }
  };

  const handleBlurEvent = (dataField, updatedValue, newFormData) => {
    if (props.onFormFieldBlur) {
      props.onFormFieldBlur(dataField, updatedValue, newFormData)
    }
  }

  const handleOnValidateField = (dataField,updatedValue) => {
    let validationObj = { ...validState }
    let newFormData = { ...formData };
    if (updatedValue !== undefined) {   // to drop-down select case
      newFormData[dataField] = updatedValue;
    }
    if (validationRules[dataField]) {
      const validation = Validate(formData, validationRules, dataField);
      if (!validation.isValid) {
        validationObj.error[dataField] = validation.error[dataField];
        validationObj.isValid = false;
        setValidState(validationObj);
      }else if (dataField === "confirmNewPassword" && newFormData?.confirmNewPassword != newFormData?.newPassword) { // validate confirm password
        validationObj.isValid = true;
        validationObj.error[dataField] = "Password does not match";
        setValidState(validationObj);
      }
      else {
        if (validationObj.error[dataField]) {
          delete validationObj.error[dataField];
          setValidState(validationObj);
        }
      }
    }
    handleBlurEvent(dataField,newFormData[dataField],newFormData);
  };

  const onActionHandle = (action, dataField, data) => {
    if (props.onActionChange && props.onActionChange[action]) {
      props.onActionChange[action](data, dataField, formData);
    }
  }
  const handleTableDelete = (data) => {
    if (props.handleTableDelete) {
      props.handleTableDelete(data)
    }
  };
  const handleTableEdit = (data) => {
    if (props.handleTableEdit) {
      props.handleTableEdit(data)
    }
  };
  return (
    <>
      {props.formFields ? (
        <FormFields
          fields={props.formFields}
          formData={formData}
          validState={validState}
          onActionChange={onActionHandle}
          onFormStateChange={handleStateChange}
          onFormFieldChange={handleFormFieldChange}
          onUpdateValidation={handleOnValidateField}
          formSetting={props.formSetting}
          fieldValiadtionRules={validationRules}
          handleTableEdit={handleTableEdit}
          handleTableDelete={handleTableDelete}
        />
      ) : (
        <div>No fields configured</div>
      )}
    </>
  );
});

FormCreator.propTypes = {
  name: PropTypes.string,
  initialState: PropTypes.object,
  formFields: PropTypes.array,
  onFormDataChange: PropTypes.func,
  onFormFieldValueChange: PropTypes.func,
  onFormFieldBlur: PropTypes.func,
};

export default FormCreator;